export default __webpack_public_path__ + "static/media/sidebar-bg.6dfbf399.png";